export default "__VITE_ASSET__r89T35zQ__"